module.exports = __webpack_public_path__ + "static/media/Illus-Employee_2@2x.a494d53d.png";